
define('ldsh!modules/editor/templates/controls/resize_left', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="handle cl" id="lpg-w"></div>';

}
return __p
};});

